/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_FilterInputs */

const cs_gdpr_audit_filter = /** @type {(inputs: Gdpr_Audit_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat`)
};

const en_gdpr_audit_filter = /** @type {(inputs: Gdpr_Audit_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Gdpr_Audit_FilterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_filter = /** @type {((inputs?: Gdpr_Audit_FilterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_FilterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_filter(inputs)
	return cs_gdpr_audit_filter(inputs)
});